import { render } from "./index.vue?vue&type=template&id=54fbc0e9&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=54fbc0e9&lang=less&scoped=true"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fbc0e9"]])

export default __exports__